// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"684":"2b0e5d50","708":"c0d36417"}[chunkId] + ".chunk.js";
};